import Link from 'next/link'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  link: string
  title: string[] | string
  address: string
  query?: string
  course?: string[]
  isCoupon: boolean
  state?: number | string
  img?: string
  stampBool?: boolean
  point?: number
}

type SpotListComponentType = {
  title: string[] | string
  address: string
  course?: string[]
  isCoupon: boolean
}

const List = ({ link, title, address, query, course, isCoupon, state, img, stampBool, point }: Props) => {
  const SpotListComponent = memo(({ title, address, course, isCoupon }: SpotListComponentType) => {
    const { t } = useTranslation()
    return (
      <div className="ml-2 flex-1">
        <p className="text-sm font-bold">{title}</p>
        <p className="text-xsss">{address}</p>
        <div className="mt-1 flex items-center">
          {!stampBool ? (
            <>
              <p className="c-tag mr-2 text-xs text-sub">{course}</p>
              {isCoupon && (
                <p className="c-tag c-tag--coupon c_clamp mr-2 inline-block text-xss">
                  {t('spot_detail.coupon', 'クーポン')}
                </p>
              )}
            </>
          ) : (
            <>
              <p className="mr-2 text-xs text-color01">{`${
                state === 0 ? t('spot_detail.un_acquired', '未獲得') : t('spot_detail.acquired', '獲得済み')
              }`}</p>
              {course
                ? course.map((v, i) => {
                    return (
                      <p className="c-tag c_clamp mr-2 inline-block text-xss text-sub" key={v}>
                        {v}
                      </p>
                    )
                  })
                : ''}
              {isCoupon && (
                <p className="c-tag c-tag--coupon c_clamp mr-2 inline-block text-xss">
                  {t('spot_detail.coupon', 'クーポン')}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    )
  })

  SpotListComponent.displayName = 'SpotListComponent'

  return (
    <Link
      href={{
        pathname: `${link}`,
        query: {
          query: query,
        },
      }}
    >
      <a className="border-gray-200 flex items-center border-b py-3">
        {(() => {
          if (img) {
            return (
              <div className="c-thumbnail_min-wrap">
                <span className="c-thumbnail_min block">
                  <img src={img} alt="" />
                </span>
              </div>
            )
          }
          return
        })()}
        <SpotListComponent title={`${title}`} address={address} course={course} isCoupon={isCoupon} />
        {point && (
          <div className="text-[20px] font-bold">
            {point}
            <span className="text-[16px]">pt</span>
          </div>
        )}
      </a>
    </Link>
  )
}

export default List
